import { SvgSprite } from "@skv/core";

interface ExternalLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  iconSize?: number | null;
  children: React.ReactNode;
}

export const ExternalLink = ({
  children,
  iconSize = 12,
  ...rest
}: ExternalLinkProps) => {
  return (
    <a {...rest} target="_blank" rel="noopener noreferrer">
      {children}
      {iconSize ? (
        <SvgSprite
          id="icons:external"
          width={iconSize}
          height={iconSize}
          aria-label="Opens in a new tab"
          className="ml-1"
        />
      ) : (
        <span className="sr-only">Opens in a new tab</span>
      )}
    </a>
  );
};
